import { render, staticRenderFns } from "./CAVPaginationV2.vue?vue&type=template&id=0ccbdb96&scoped=true"
import script from "./CAVPaginationV2.vue?vue&type=script&lang=js"
export * from "./CAVPaginationV2.vue?vue&type=script&lang=js"
import style0 from "./CAVPaginationV2.vue?vue&type=style&index=0&id=0ccbdb96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccbdb96",
  null
  
)

export default component.exports